import { IObjectTranslatable } from ".";
import { INewPageItemBean, ITypeDefinable, BeanTypes } from "../beans/items";
import { IItem, NewPageItem } from "../../../../domain/document/items";

import {
  Point,
  Vector,
} from "../../../../domain/drawing";

export class NewPageItemTranslator implements IObjectTranslatable {
  toItem(item: ITypeDefinable, formatId: number, groupId: number, documentId: number, executionMode: string): IItem {
    const bean = item as INewPageItemBean;
    const result = new NewPageItem();
    result.privateId = (bean as any).privateId; // フロントエンド独自パラメータ.
    result.uniqueKey = bean.uniqueKey;
    result.id = bean.id;
    result.sectionObjectUid = bean.sectionObjectUid;
    result.isEditable = true;
    result.isAdditional = !!bean.isAdditional;
    result.isDeleted = !!bean.isDeleted;
    result.isVisible = !bean.isDeleted;
    result.typeDetail = bean.typeDetail;
    result.viewTitle = bean.viewTitle;
    result.vector = new Vector(new Point(bean.lineStartX, bean.lineStartY), new Point(bean.lineEndX, bean.lineEndY));
    return result;
  }

  toBean(item: IItem): INewPageItemBean {
    const target = item as NewPageItem;
    return {
      type: BeanTypes.NewPage,
      uniqueKey: target.uniqueKey,
      id: target.id,
      sectionObjectUid: target.sectionObjectUid,
      isAdditional: target.isAdditional,
      isDeleted: target.isDeleted,
      lineStartX: Math.floor(target.vector.from.x),
      lineStartY: Math.floor(target.vector.from.y),
      lineEndX: Math.floor(target.vector.to.x),
      lineEndY: Math.floor(target.vector.to.y),
      typeDetail: target.typeDetail,
      viewTitle: target.viewTitle,
    };
  }
}
